<template>
    <div class="com-partm9">
        <MyTitle title="GPU高负载服务器" />
        <div class="p-content">
			<div
				v-for="(item, i) in loadList"
				:key="'loadList' + i"
				class="load-list">
				<div class="flex item-t align-center">
					<div class="icon-bg flex justify-center align-center">{{ i + 1 }}</div>
					<div>{{ item.ip }}</div>
				</div>
				<div class="flex item-b  align-center">
					<div class="flex1 item-l">
						<div class="solid" :style="{'width': `${item.num}%`}"></div>
					</div>
					<div class="flexs flex justify-center item-r">{{ item.num }}% </div>
				</div>
			</div>
        </div>
    </div>
</template>

<script>
import MyTitle from './myTitle1.vue'
import { dataInterface } from "@/api/dataInterfaceApi"
export default {
    components: {
        MyTitle,
    },
    data() {
        return {
			loadList: []
        }
    },
	mounted() {
        // GPU高负载服务器
        this.getData()
    },
	methods: {
        // GPU高负载服务器
        getData() {
			let params = { 
				enCode: 'computingpower-right-gpugfzfwq',
			}
			dataInterface.dataFaceApi(params).then(res => {
				console.log(res, 'GPU高负载服务器')
                let data = res || []
				this.loadList = data.map((item, i) => {
                    return {
							ip: item.host,
							num: parseInt(item.gpuLoad || 0, 10)
						}
                })
			})
        },
    }
}
</script>

<style lang="scss" scoped>
@import './comm.scss';
.com-partm9 {
    .p-content {
		.load-list {
			.item-b {
				.item-l {
					background-color: rgba(208, 222, 238, 0.1) !important;
					.solid {
						background: linear-gradient(270deg, #1FFAFF 1.64%, #E2FFFD 100%) !important;
					}
				}
			}
		}
    }
}
</style>